import React from "react";
import { useHistory } from "react-router-dom";
import { PortalButton } from "./portal_button";

interface PortalBackButtonProps {
  children?: string;
  onClick?: () => void;
}

export function PortalBackButton({ children, onClick }: PortalBackButtonProps) {
  const history = useHistory();

  return (
    <PortalButton
      appearance="text"
      leftIconName="chevron-left"
      onClick={onClick || history.goBack}
    >
      {children}
    </PortalButton>
  );
}
